import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import { useOrganisation } from 'src/organisation';

import { Iconify } from 'src/components/iconify';

import { startIssueReport } from './issue-report';
import { useIsIntercomMessengerReady } from './intercom-messenger-provider';

// ----------------------------------------------------------------------

export type ReportIssueButtonLayout = 'labelled' | 'icon';

type LauncherProps = {
  onClick: () => void;
};

const LABEL = 'Report an issue';

const ICON = <Iconify icon="solar:bug-bold-duotone" />;

const NAV_TEXT_COLOR = 'var(--layout-nav-text-secondary-color)';

function LabelledLauncher({ onClick }: LauncherProps) {
  return (
    <Box sx={{ px: 2, py: 1.5 }}>
      <Button
        fullWidth
        startIcon={ICON}
        onClick={onClick}
        sx={{ justifyContent: 'flex-start', color: NAV_TEXT_COLOR }}
      >
        {LABEL}
      </Button>
    </Box>
  );
}

function IconLauncher({ onClick }: LauncherProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 1.5 }}>
      <Tooltip title={LABEL} placement="right">
        <IconButton aria-label={LABEL} onClick={onClick} sx={{ color: NAV_TEXT_COLOR }}>
          {ICON}
        </IconButton>
      </Tooltip>
    </Box>
  );
}

const LAUNCHERS = {
  labelled: LabelledLauncher,
  icon: IconLauncher,
} satisfies Record<ReportIssueButtonLayout, React.ComponentType<LauncherProps>>;

export function ReportIssueButton({ layout }: { layout: ReportIssueButtonLayout }) {
  const isReady = useIsIntercomMessengerReady();
  const { id, organizationId } = useOrganisation();

  if (!isReady) return null;

  const Launcher = LAUNCHERS[layout];

  return (
    <Launcher
      onClick={() => startIssueReport({ userId: id, organizationId: String(organizationId) })}
    />
  );
}
